import React from "react";
import { SxProps, Toolbar, Stack, Typography, styled, IconButton } from "@mui/material";

import { useNavigate } from "react-router";

import CloseIcon from "@mui/icons-material/Close";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { useDispatch, useSelector } from "react-redux";
import { SetLastPath, GetLastPath } from "../../../Redux/Reducers/redux-slice-basket";

export interface FullTaskTopbarProps {
  sx?: SxProps;
  backRoute?: string;
  title: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  closeOption?: boolean;
  onClose?: () => void;
}

const FullTaskTopbar: React.FC<FullTaskTopbarProps> = (props) => {
  const { title, backRoute, leftContent, rightContent, sx = {}, closeOption = true, onClose } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lastPath = useSelector(GetLastPath);

  const onClickClose = React.useCallback(() => {
    onClose && onClose();
    if (lastPath.length > 0) {
      navigate(lastPath);
      dispatch(SetLastPath(""));
    } else {
      if (!backRoute) return;
      navigate(backRoute);
    }
  }, [navigate, backRoute]);

  return (
    <Appbar sx={sx} position="absolute">
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <a
            href={lastPath.length > 0 ? lastPath : backRoute}
            onClick={(e) => {
              // prevent handle click but keep mousewheel click.
              e.preventDefault();
            }}
          >
            {closeOption && (
              <IconButton aria-label="Close" onClick={onClickClose}>
                <CloseIcon />
              </IconButton>
            )}
          </a>
          <Typography component="h1" variant="h5" color="text.primary">
            {title}
          </Typography>
          {leftContent}
        </Stack>
        <Stack direction="row" spacing={1}>
          {rightContent}
        </Stack>
      </Toolbar>
    </Appbar>
  );
};

interface AppbarProps extends MuiAppBarProps {}

const Appbar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppbarProps>(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: theme.palette.background.default,
  ".MuiToolbar-root": {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
}));

export default FullTaskTopbar;
